var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52619",
    "data-name": "Group 52619",
    transform: "translate(-980 -249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18698",
    "data-name": "Rectangle 18698",
    transform: "translate(980 249)",
    fill: "#fff",
    stroke: "#93a750",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 11.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M17.411,4.558H2.28A2.279,2.279,0,1,1,2.28,0H17.411a2.279,2.279,0,1,1,0,4.558",
    transform: "translate(990.154 266.721)",
    fill: "#93a750"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMines);
export default __webpack_public_path__ + "static/media/Mines.9189dd2407bff537eb5a8ea4db45db19.svg";
export { ForwardRef as ReactComponent };